import ModalProvider from "./ModalProvider";

export { ModalProvider as default };
